// ----------------------------------------------------------------
// CBS grid keyboard navigation
// ----------------------------------------------------------------
// Attach onKeyDown={enterMovesDown} to a data-entry container (a Balance Sheet
// section table, a Drop Count card, etc.). Pressing Enter in an input moves the
// cursor to the input directly BELOW it (same column); Tab keeps its native
// left-to-right behavior. Purely additive — no other keys are affected.
//
// Geometry-based (nearest input at the same horizontal center, next row down),
// so it needs no per-input wiring and works through wrapper components like
// <CountCell> via event delegation.
export function enterMovesDown(e) {
  if (e.key !== 'Enter') return;
  const el = e.target;
  if (!el || el.tagName !== 'INPUT') return;
  const scope = e.currentTarget;
  if (!scope) return;
  const r = el.getBoundingClientRect();
  const cx = r.left + r.width / 2;
  let best = null;
  let bestDy = Infinity;
  scope.querySelectorAll('input').forEach((o) => {
    if (o === el || o.disabled || o.type === 'hidden') return;
    const or = o.getBoundingClientRect();
    // same column (horizontal centers align within a few px) and strictly below
    if (Math.abs(or.left + or.width / 2 - cx) <= 12 && or.top - r.top > 2) {
      const dy = or.top - r.top;
      if (dy < bestDy) {
        bestDy = dy;
        best = o;
      }
    }
  });
  if (best) {
    e.preventDefault();
    best.focus();
    if (typeof best.select === 'function') best.select();
  }
}
